import layoutStore from "stores/layout.store";
import { environment } from "utils/config/environment";

const pushToDataLayer = (data: Record<string, unknown>) => {
  if (window) {
    if (layoutStore.isTrackingAllowed || environment.isApplicationRunningInNodeModeDevelopment()) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    } else {
      window.tempDataLayer = window.tempDataLayer || [];
      window.tempDataLayer.push(data);
    }
  }
};

export { pushToDataLayer };
